import React, { FC, useState } from 'react';
import { makeStyles, Theme, createStyles, Button, Menu, MenuItem, Typography } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useLicenseEndpoint, LicenseEndpointOption } from '../../../context/licenseEndpointContext';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		buttonLabel: {
			[theme.breakpoints.down('sm')]: {
				display: 'none'
			}
		}
	})
);

const endpointLabels: Record<LicenseEndpointOption, string> = {
	auto: 'Auto',
	arcus: 'Arcus (LAG)',
	playfactory: 'PlayFactory'
};

export const LicenseEndpointSelector: FC = () => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const { selectedEndpoint, setSelectedEndpoint } = useLicenseEndpoint();

	const handleMenuClick = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (): void => {
		setAnchorEl(null);
	};

	const handleSelection = (endpoint: LicenseEndpointOption): void => {
		handleClose();
		setSelectedEndpoint(endpoint);
	};

	return (
		<div>
			<Button
				data-testid='license-endpoint-selector'
				aria-label='License Endpoint Selector'
				variant='contained'
				color='primary'
				disableElevation
				startIcon={<SettingsIcon />}
				endIcon={<KeyboardArrowDownIcon />}
				onClick={handleMenuClick}>
				<Typography className={classes.buttonLabel} variant='button'>
					{endpointLabels[selectedEndpoint]}
				</Typography>
			</Button>
			<Menu
				data-testid='license-endpoint-menu'
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				open={open}
				onClose={handleClose}>
				{(Object.keys(endpointLabels) as LicenseEndpointOption[]).map((endpoint) => (
					<MenuItem
						key={endpoint}
						data-testid={`license-endpoint-menu-${endpoint}`}
						onClick={(): void => handleSelection(endpoint)}>
						<Typography variant='button'>{endpointLabels[endpoint]}</Typography>
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};
